<template>
    <div v-if="loaded">
        <kendo-multiselect
            :ref="'multiselect' + _uid"
            v-if="loaded"
            v-model="selected"
            :data-source="items"
            :data-text-field="'text'"
            :data-value-field="'id'"
            :data-placeholder="$t('choose')"
            :filter="filterPattern"
            :readonly="readonly"
            :popup="bindPopup && popupContainerId ? popup : {}"
            @change="inputChanged"
            :name="'dropdown' + _uid"
            :data-vv-as="fieldName"
            :auto-width="autoWidth"
            :clear-button="clearButton"
            v-validate="required ? 'required' : ''"
            :footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
            :height="height"
            style="width: 100%;"
        ></kendo-multiselect>
        <span
            class="text-danger col-12"
            v-if="errors.has('dropdown' + _uid)"
        >{{ errors.first('dropdown' + _uid) }}</span>

        <DropdownSettings
            v-if="loaded"
            :filterPattern.sync="filterPattern"
            :show.sync="showSettings"
        ></DropdownSettings>
    </div>
</template>

<script>
import Vue from "vue";
import FooterTemplate from "@/components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "@/components/common/DropdownSettings";
import { mapGetters } from "vuex";

export default {
    inject: ["$validator"],
    components: {
        DropdownSettings,
    },
    props: {
        apiUrl: {
            type: String,
            required: true,
        },
        value: [String, Number, Array, Object],
        requestParams: {
            type: Array,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        fieldName: String,
        registerName: String,
        filter: {
            type: String,
            default: "none",
        },
        height: {
            type: Number,
            default: 400, // 200 - Default value for Kendo DropdownList
        },
        itemsFromParent: {
            type: Array,
            default: () => [],
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        autoWidth: {
            type: Boolean,
            default: false,
        },
        clearButton: {
            type: Boolean,
            default: true,
        },
        bindPopup: {
            type: Boolean,
            default: false,
        },
        popupContainerId: {
            type: String,
            default: "",
        },
        showAddThematicAreaBtn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selected: this.value,
            items: [],
            changedFromDropdown: false,
            loaded: false,
            showSettings: false,
            filterPattern: "",
            popup: {
                appendTo: $(this.popupContainerId),
            },
        };
    },
    methods: {
        loadItems() {
            this.loaded = false;
            if (this.itemsFromParent.length > 0) {
                this.items = this.itemsFromParent;
                this.loaded = true;
            } else if (this.requestParams) {
                this.$http
                    .post(this.apiUrl, this.requestParams)
                    .then((result) => {
                        // TODO
                        this.items = [];
                        result.data.forEach((item) => {
                            this.items.push({
                                id: item.id,
                                text:
                                    this.isEnVersion && item.textEn
                                        ? item.textEn
                                        : item.text,
                                isRegisterField: item.isRegisterField,
                                item: item
                            });
                        });
                        this.loaded = true;
                        // this.items = result.data;
                    })
                    .catch((error) => {
                        // TODO: Toast
                    });
            } else {
                // TODO: Loading

                let initValue = this.value;
                if (initValue && Array.isArray(initValue)) {
                    initValue = initValue.join('|')
                }

                this.$http
                    .get(this.apiUrl, { params: { value: initValue } })
                    .then((result) => {
                        // TODO
                        this.items = [];
                        result.data.forEach((item) => {
                            this.items.push({
                                id: item.id,
                                text:
                                    this.isEnVersion && item.textEn
                                        ? item.textEn
                                        : item.text,
                                isRegisterField: item.isRegisterField,
                                item: item
                            });
                        });
                        this.loaded = true;
                        // this.items = result.data;
                    })
                    .catch((error) => {
                        // TODO: Toast
                    });
            }
        },
        inputChanged(event) {
            const val = event.sender.value();
            if (!this.items) {
                return this.$emit("input", val);
            }

            if (Array.isArray(val)) {
                let items = this.items.filter((i) => val.includes(i.id));
                this.$emit("input", val, items);
            } else {
                let item = this.items.filter((i) => i.id === val);
                this.$emit("input", val, item);
            }
        },
        templateBtns(e) {
            return [
                this.showAddThematicAreaBtn
                    ? {
                        name: "addThematicAreaRegisterEntry",
                        text: this.$t("buttons.add.btnText"),
                        tooltip: this.$t("buttons.add.btnText"),
                        class: "btn btn-secondary",
                        icon: "far fa-plus-square",
                        show: true,
                        clickHandler: this.addThematicAreaRegisterEntry,
                    }
                    : {},
                {
                    name: "refreshContent",
                    text: this.$t("buttons.reload.btnText"),
                    tooltip: this.$t("buttons.reload.btnText"),
                    class: "btn btn-secondary",
                    icon: "fas fa-sync",
                    show: true,
                    clickHandler: this.loadItems,
                }
            ];
        },
        addThematicAreaRegisterEntry() {
            if (this.hasCreateThematicAreaRights) {
                let routeData = this.$router.resolve({ name: 'createThematicArea' })
                window.open(routeData.href, '_blank')
            }
        },
        footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        ...this.templateBtns(e),
                        {
                            name: "selectAll",
                            text: this.$t("buttons.selectAll.btnText"),
                            tooltip: this.$t("buttons.selectAll.tooltipText"),
                            class: "btn btn-secondary",
                            icon: "far fa-check-square",
                            show: true,
                            clickHandler: this.selectAll,
                        },
                        {
                            name: "selunselectAllectAll",
                            text: this.$t("buttons.unselectAll.btnText"),
                            tooltip: this.$t("buttons.unselectAll.tooltipText"),
                            class: "btn btn-secondary",
                            icon: "far fa-square",
                            show: true,
                            clickHandler: this.unselectAll,
                        },
                        {
                            name: "dynamicMultiSelectSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
        selectAll() {
            const multiSelect = this.$refs[`multiselect${this._uid}`];
            if (!multiSelect) return;

            const values = multiSelect.kendoWidget().dataSource.view().map(x => {
                if (x.hasOwnProperty('id')) {
                    return x.id;
                }

                if (x.hasOwnProperty('value')) {
                    return x.value;
                }
            });

            if (values) {
                this.selected = values;
                this.$emit('input', this.selected);
            }
        },
        unselectAll() {
            if (Array.isArray(this.selected)) {
                this.selected.splice(0);
            }
        },
    },
    mounted() {
        this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;
        this.loadItems();
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal, oldVal) {
                if (this.changedFromDropdown) {
                    this.changedFromDropdown = false;
                    return;
                }
                this.selected = newVal;
            },
        },
        apiUrl: {
            immediate: true,
            handler(newVal, oldVal) {
                if (this.changedFromDropdown) {
                    this.changedFromDropdown = false;
                    return;
                }
                this.apiUrl = newVal;
                this.loadItems();
            },
        },
        requestParams: {
            immediate: true,
            handler(newVal, oldVal) {
                this.loadItems();
            },
        },
    },
    computed: {
        ...mapGetters(['isEnVersion', 'nomDropdownSettings', 'claims']),
        hasCreateThematicAreaRights() {
            return this.claims.registers.create;
        },
    },
};
</script>
